import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {RequestStatus} from 'requests/RequestConstants';
import {BLUE_LIGHT, GRAY_DARK, GREEN, RED} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export const REQUEST_STATUS_ICONS: Record<RequestStatus, {icon: BenchlingIconName; style: {color: string}}> =
  {
    [RequestStatus.REQUESTED]: {
      icon: 'request-pending',
      style: {color: GRAY_DARK},
    },
    [RequestStatus.SCHEDULED]: {
      icon: 'request-scheduled',
      style: {color: GRAY_DARK},
    },
    [RequestStatus.IN_PROGRESS]: {
      icon: 'request-in-progress',
      style: {color: BLUE_LIGHT},
    },
    [RequestStatus.COMPLETED]: {
      icon: 'request-executed',
      style: {color: GREEN},
    },
    [RequestStatus.CANCELLED]: {
      icon: 'cancelled',
      style: {color: RED},
    },
  };

interface RequestStatusIconProps {
  status: RequestStatus;
  className?: string;
}

export function RequestStatusIcon(props: RequestStatusIconProps): JSX.Element {
  return (
    <BenchlingIcon
      icon={REQUEST_STATUS_ICONS[props.status].icon}
      className={classNames(props.className, css(REQUEST_STATUS_ICON_STYLES[props.status]))}
    />
  );
}

export const REQUEST_STATUS_ICON_STYLES = StyleSheet.create(
  _.mapObject(REQUEST_STATUS_ICONS, (info) => ({...info.style}))
);
